<template>
  <b-container fluid class="property-sheet">
    <b-row class="properties no-gutters" v-if="type !== ''">
      <b-col class="property" cols="12" md="6">Tipo</b-col>
      <b-col class="value" cols="12" md="6">{{ type }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="color !== ''">
      <b-col class="property" cols="12" md="6">Color</b-col>
      <b-col class="value" cols="12" md="6">{{ color }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="cc !== ''">
      <b-col class="property" cols="12" md="6">C.C.</b-col>
      <b-col class="value" cols="12" md="6">{{ cc }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="fuel !== ''">
      <b-col class="property" cols="12" md="6">Combustible</b-col>
      <b-col class="value" cols="12" md="6">{{ fuel }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="mileage !== ''">
      <b-col class="property" cols="12" md="6">Kilometraje / Millas</b-col>
      <b-col class="value" cols="12" md="6">{{ mileage }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="cilinders !== ''">
      <b-col class="property" cols="12" md="6">Cilindros</b-col>
      <b-col class="value" cols="12" md="6">{{ cilinders }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="doors !== ''">
      <b-col class="property" cols="12" md="6">Puertas</b-col>
      <b-col class="value" cols="12" md="6">{{ doors }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="keys !== ''">
      <b-col class="property" cols="12" md="6">Llaves</b-col>
      <b-col class="value" cols="12" md="6">{{ keys }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="source !== ''">
      <b-col class="property" cols="12" md="6">Agencia o Rodado</b-col>
      <b-col class="value" cols="12" md="6">{{ source }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="transmission !== ''">
      <b-col class="property" cols="12" md="6">Transmisión</b-col>
      <b-col class="value" cols="12" md="6">{{ transmission }}</b-col>
    </b-row>
    <b-row class="properties no-gutters" v-if="details !== ''">
      <b-col class="property" cols="12" md="6">Características</b-col>
      <b-col class="value" cols="12" md="6">{{ details }}</b-col>
    </b-row>
    <b-row class="properties featured no-gutters" v-if="code !== ''">
      <b-col class="property" cols="12" md="6">Código</b-col>
      <b-col class="value" cols="12" md="6">{{ code }}</b-col>
    </b-row>
    <b-row class="properties featured no-gutters" v-if="base > 0">
      <b-col class="property" cols="12" md="6">Precio base</b-col>
      <b-col class="value" cols="12" md="6">{{ base | currency }}</b-col>
    </b-row>
  </b-container>
</template>

<script>
import utils from "../../assets/js/utils";

export default {
  name: "PropertySheet",
  props: {
    id: {
      type: String,
      default: "0",
    },
    type: {
      type: String,
      default: "",
    },
    base: {
      type: Number,
      default: 0,
    },
    cc: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    fuel: {
      type: String,
      default: "",
    },
    mileage: {
      type: String,
      default: "0",
    },
    cilinders: {
      type: String,
      default: "0",
    },
    doors: {
      type: String,
      default: "0",
    },
    keys: {
      type: String,
      default: "",
    },
    source: {
      type: String,
      default: "",
    },
    code: {
      type: String,
      default: "",
    },
    transmission: {
      type: String,
      default: "",
    },
    details: {
      type: String,
      default: "",
    },
  },
  filters: {
    currency: function(amount) {
      return utils.formatCurrency(amount);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.property-sheet {
  background-color: $white;
  height: 100%;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  @media (max-width: viewport-min-size("lg")) and (max-width: prev-viewport-max-size("lg")) {
    font-size: 0.9rem;
  }
}

.properties {
  padding-bottom: 0.25rem;
  margin-bottom: 0.25rem;
  border-bottom: 1px solid $gray;

  &.featured {
    color: $red;
    font-weight: $font-weight-bold;
  }

  .value {
    font-weight: $font-weight-bold;
  }
}
</style>
